@import '~style-sheet-helpers/core.less';
@import '../../../../../../../constants/spacing.module.less';

.dropdown-title {
  font-size: 16px;
  margin-top: @space-24;
}

.dropdown-optional-message {
  font-weight: @normal;
  margin-left: @space-4;
  color: var(--default--disabled--text-color--4);
}

.default-dropdown-item {
  color: var(--default--disabled--text-color--4);
}

.dropdown-container {
  align-items: start;
  column-gap: @space-32;
}

.dropdown-wrapper {
  flex: 1;
}

.dropdown-menu {
  margin-top: @space-4;
}
